import { FeatureFlag } from '../FeatureFlag';

export const enableOrderDebugFiltering = new FeatureFlag({
    key: 'enable-order-debug-filtering',
    defaultValue: false,
});
